import { InjectionToken } from "@angular/core";
import { AuthService } from "../auth.service";

export const IAUTH_SERVICE = new InjectionToken<IAuthService>("authToken", {
  providedIn: "root",
  factory: () => new AuthService()
});

export interface IAuthService {
  redirectUrl: string;
  IsActor(roles: string[]): Boolean;
  IsISOperator(roles: string[]): Boolean;
  IsFundAdmin(roles: string[]): Boolean;
  IsSupervisor(roles: string[]): Boolean;
}
